// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"81a9cd4c","58":"ec150718","79":"4d085e77","158":"5edc791f","250":"c28b3223","372":"9cda1059","446":"9e3def1c","504":"fabe41dc","702":"c101df1a","795":"95140eb0","879":"e1d7ab81","917":"ec67ceca","934":"2a52e96a","947":"a6ab3c2e"}[chunkId] + ".chunk.js";
};